import React, { useRef } from 'react';

import { CMSReferences } from '@swf/cms';
import type * as CMSContent from '@swf/cms';

import useSetHeaderHeight from '../hooks/useSetHeaderHeight';

interface Props {
  layoutRef: React.RefObject<HTMLDivElement>;
  references?: CMSContent.Reference[];
}

const Header: React.FC<Props> = ({ layoutRef, references }) => {
  const headerRef = useRef<HTMLDivElement>(null);

  useSetHeaderHeight(layoutRef, headerRef);

  if (!references) return null;

  return (
    <div ref={headerRef}>
      <CMSReferences references={references} />
    </div>
  );
};

export default Header;
